var initialState = {
  id: '',
  title: '',
  description: '',
  referral_bonus: false,
  fine_print: '',
  required_referrals: '',
  expire_date: '',
  receiver_perk_id: '',
  bonus_perks: [],
  merchant: ''
};

export default function perkForm(state = initialState, action) {
  switch (action.type) {
    case 'PERK_GET':
      return {
        ...state,
        id: action.payload.id ? action.payload.id : initialState.id,
        title: action.payload.title ? action.payload.title : initialState.title,
        description: action.payload.description ? action.payload.description : initialState.description,
        referral_bonus: action.payload.referral_bonus ? action.payload.referral_bonus : initialState.referral_bonus,
        fine_print: action.payload.fine_print ? action.payload.fine_print : initialState.fine_print,
        required_referrals: action.payload.required_referrals ? action.payload.required_referrals : initialState.required_referrals,
        expire_date: action.payload.expire_date ? action.payload.expire_date : initialState.expire_date,
        receiver_perk_id: action.payload.receiver_perk_id ? action.payload.receiver_perk_id : initialState.receiver_perk_id,
        bonus_perks: action.payload.bonus_perks ? action.payload.bonus_perks : initialState.bonus_perks,
        merchant: action.payload.merchant ? action.payload.merchant : initialState.merchant,
      };
    case 'SET_PERK_FORM':
      return {
        ...state,
        id: action.payload.id ? action.payload.id : initialState.id,
        title: action.payload.title ? action.payload.title : initialState.title,
        description: action.payload.description ? action.payload.description : initialState.description,
        referral_bonus: action.payload.referral_bonus ? action.payload.referral_bonus : initialState.referral_bonus,
        fine_print: action.payload.fine_print ? action.payload.fine_print : initialState.fine_print,
        required_referrals: action.payload.required_referrals ? action.payload.required_referrals : initialState.required_referrals,
        expire_date: action.payload.expire_date ? action.payload.expire_date : initialState.expire_date,
        receiver_perk_id: action.payload.receiver_perk_id ? action.payload.receiver_perk_id : initialState.receiver_perk_id,
        bonus_perks: action.payload.bonus_perks ? action.payload.bonus_perks : initialState.bonus_perks,
        merchant: action.payload.merchant ? action.payload.merchant : initialState.merchant,
      };
    case 'RESET_PERK_FORM':
      return initialState;
    default:
      break;
  }
  return state;
}


/** WEBPACK FOOTER **
 ** ./src/reducers/forms/perkForm.js
 **/